import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { findLikertRange, LIKERT_COLORS, toNumber } from './likertHelpers';

const styles = {
  bar: {
    backgroundColor: '#eef0f3',
    display: 'flex',
    overflow: 'hidden',
    width: '100%',
  },
  slice: {
    alignItems: 'center',
    color: '#fff',
    display: 'flex',
    fontWeight: 700,
    justifyContent: 'center',
    minWidth: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
};

function LikertSegmentBar({
  faixas,
  height = 22,
  fontSize = 11,
  radius = 6,
  decimais = 0,
}) {
  const intl = useIntl();
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const node = ref.current;

    if (!node || typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver((entries) => {
      setWidth(entries[0]?.contentRect?.width || 0);
    });

    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  const segments = [
    {
      code: 'negativa',
      label: intl.formatMessage({ id: 'labelLikertNegativa' }),
      color: LIKERT_COLORS.negativa,
    },
    {
      code: 'neutra',
      label: intl.formatMessage({ id: 'labelLikertNeutra' }),
      color: LIKERT_COLORS.neutra,
    },
    {
      code: 'positiva',
      label: intl.formatMessage({ id: 'labelLikertPositiva' }),
      color: LIKERT_COLORS.positiva,
    },
  ].map((segment) => ({
    ...segment,
    percentual: toNumber(findLikertRange(faixas, segment.code).percentual),
  }));

  return (
    <div ref={ref} style={{ ...styles.bar, borderRadius: radius, height }}>
      {segments.map((segment) => {
        if (segment.percentual <= 0) return null;

        const text = `${intl.formatNumber(segment.percentual, {
          maximumFractionDigits: decimais,
        })}%`;
        const segmentWidth = (segment.percentual / 100) * width;
        const estimatedTextWidth = text.length * fontSize * 0.62 + 8;
        const showText = width > 0 && segmentWidth >= estimatedTextWidth;

        return (
          <div
            key={segment.code}
            style={{
              ...styles.slice,
              backgroundColor: segment.color,
              flexBasis: `${segment.percentual}%`,
              fontSize,
            }}
            title={`${segment.label}: ${intl.formatNumber(segment.percentual, {
              maximumFractionDigits: 1,
            })}%`}
          >
            {showText ? text : ''}
          </div>
        );
      })}
    </div>
  );
}

export default LikertSegmentBar;
